<template>
  <div>
    <my-head></my-head>
    <div class="operationaldevelopment minH">
      <div class="crumbs">
        首页 > 运营服务 >
        <span style="color: #1d2129">IP运营开发</span>
      </div>

      <div class="title">IP运营开发</div>

      <div class="content">
        知识产权运营指知识产权权利人和相关市场主体优化资源配置，采取一定的商业模式实现知识产权价值的商业活动。通过知识产权运营，知识产权权利人可以获得相应的市场回报，企业可以拥有发展壮大的优质创新资源，政府可以有效推动经济的转型和升级。<br />
        由于知识资产的外观和感觉不具有实物性，知识被人们看成其本身就是一种不同于实物资产的“无形资产”。由于知识经济的迅猛发展，知识资产在市场竞争中的作用日益凸显，知识资产成为一种重要的竞争性资源，而专利等知识产权已经成为含金量最高的资本。日本企业已将专利知识产权列入人、财、物之后的“第四经营资源”；美国则将知识产权视为维护美国技术边界的重要“国家资源”。从企业经营管理的角度来说，运用知识资产参与市场竞争的表现形式已由静态的技术层面上升为动态的运用层面，即知识产权运营。知识产权运营不仅是发挥知识资产竞争优势的关键手段，也可以实现自身知识产权利益的最大化。知识产权运营将知识产权与现代企业相结合，将知识产权与产业进行联姻，推动产业结构优化升级，导航产业高端发展，促进企业提升核心竞争力。
      </div>

      <img
        src="../../assets/operationaldevelopment_1.png"
        class="operationaldevelopment_img"
      />
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../../components/MyHead.vue";
import MyFooter from "../../components/MyFooter.vue";
export default {
  components: { MyHead, MyFooter },
};
</script>

<style lang="scss">
.operationaldevelopment {
  width: 80%;
  margin: 24px auto 60px;
  .operationaldevelopment_img {
    width: 100%;
    margin-bottom: 130px;
  }
  .content {
    font-size: 14px;
    margin-bottom: 32px;
    font-weight: 400;
    color: #4e5969;
    line-height: 28px;
  }
  .title {
    font-size: 30px;
    margin-bottom: 32px;
    font-weight: bold;
    color: #1d2129;
    line-height: 38px;
  }
}
</style>
